var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("rect",{"width":"40","height":"40","fill":"currentColor"}))),React.createElement("g",{"transform":"translate(-24 -5)","key":1},React.createElement("g",{"transform":"translate(24 5)","clipPath":"url(#a)"},[React.createElement("path",{"d":"M20,40A20,20,0,1,0,0,20,20,20,0,0,0,20,40","fill":"currentColor","fillRule":"evenodd","key":0}),React.createElement("path",{"d":"M24.289,35.786V24.243H21.943V20.416h2.346V18.1c0-3.121.933-5.372,4.351-5.372h4.065v3.819H29.842c-1.433,0-1.76.953-1.76,1.95v1.917h4.411l-.6,3.827H28.082V35.786Z","transform":"translate(-7.314 -4.243)","fill":"#fff","fillRule":"evenodd","key":1})]))]);
}

IconFacebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
